import React, { useState, useEffect } from "react";
import "./SideApp.css";
import UserInfoDetails from "./UserInfoDetails";
import UserInfoDetails2 from "./UserInfoDetails2";
import OrderTable from "./ordersTable"; // Correctly referencing the ordersTable.js

const UserInfo = () => {
    const [userInfo, setUserInfo] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [shopifyData, setShopifyData] = useState([]);
    const [viewMode, setViewMode] = useState("full"); // "full" or "filtered"
    const [lastOrderInfo, setLastOrderInfo] = useState({ date: null, orderNumber: null });

    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const authResponse = await fetch(
                    "https://bymolive-backend-995926394015.us-central1.run.app/api/list-users"
                );
                if (!authResponse.ok) throw new Error("Failed to fetch users.");
                const authData = await authResponse.json();

                const collectionsResponse = await fetch(
                    "https://bymolive-backend-995926394015.us-central1.run.app/api/all-collections"
                );
                if (!collectionsResponse.ok)
                    throw new Error("Failed to fetch collections.");
                const collectionsData = await collectionsResponse.json();

                const formattedData = authData.users.map((user) => {
                    const collectionMatch = collectionsData[user.email] || [];
                    const infoDoc = collectionMatch.find(
                        (doc) => doc.id === "00info"
                    );

                    return {
                        email: user.email,
                        creationDate: new Date(user.creation_time),
                        codReducere: infoDoc?.["Cod Reducere"] || "N/A",
                    };
                });

                setUserInfo(formattedData);
            } catch (err) {
                console.error(err);
            }
        };

        fetchUserInfo();

        // Load Shopify data from session storage
        const savedShopifyData = sessionStorage.getItem("shopifyData");
        if (savedShopifyData) {
            setShopifyData(JSON.parse(savedShopifyData));
        }

        const lastOrder = sessionStorage.getItem("lastOrderInfo");
        if (lastOrder) {
            setLastOrderInfo(JSON.parse(lastOrder));
        }
    }, []);

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        if (query) {
            setFilteredUsers(
                userInfo.filter(
                    (user) =>
                        user.email.toLowerCase().includes(query) ||
                        user.codReducere.toLowerCase().includes(query)
                )
            );
        } else {
            setFilteredUsers([]);
        }
    };

    const handleSelectUser = (user) => {
        setSelectedUser(user);
        setSearchQuery(`${user.email} - ${user.codReducere}`); // Update search bar content
        setFilteredUsers([]); // Clear dropdown
    };

    const filteredData = shopifyData.filter(
        (entry) =>
            viewMode === "full" ||
            entry.dbEmail === "Yes" ||
            entry.dbOrder === "Yes" ||
            entry.discountCode !== "No Discount Code"
    );

    return (
        <div className="user-info-container">
            <div className="user-access-header">
                <h1>USER INFO</h1>
                <p>Manage users and their orders.</p>
            </div>

            <div className="search-bar">
                <input
                    type="text"
                    placeholder="Search by email or Cod Reducere..."
                    value={searchQuery}
                    onChange={handleSearch}
                    className="search-input"
                />
                {filteredUsers.length > 0 && (
                    <ul className="dropdown">
                        {filteredUsers.slice(0, 5).map((user) => (
                            <li
                                key={user.email}
                                className="dropdown-item"
                                onClick={() => handleSelectUser(user)}
                            >
                                {user.email} - {user.codReducere}
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            {selectedUser && (
                <div className="details-and-orders">
                    <div className="details-section">
                        <UserInfoDetails selectedUser={selectedUser} />
                    </div>
                    <div className="orders-section">
                        <UserInfoDetails2 selectedUser={selectedUser} />
                    </div>
                </div>
            )}

            {/* Import Table Section */}
            <div className="import-section">
                <OrderTable data={filteredData} viewMode={viewMode} lastOrderInfo={lastOrderInfo} />
            </div>
        </div>
    );
};

export default UserInfo;
